import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import TuneIcon from "@mui/icons-material/Tune";
import { Autocomplete } from "@mui/material";
import Popover from "@mui/material/Popover";
import TextField from "@mui/material/TextField";
import Tooltip from "@mui/material/Tooltip";
import _, { debounce } from "lodash";
import React from "react";
import { Checkbox, Table } from "rsuite";
import { Cell, Column, HeaderCell } from "rsuite-table";
import { FormTextInput, IconButton } from "../../../../components";
import { colors } from "../../../../configs";
import LoaderComponent from "../../../common/Loader";

const ActionCell = ({
  rowData,
  dataKey,
  handleChangeDelete,
  handleChangeEdit,
  isUpdate,
  isStatus,
  handleFlag,
  leftDays,
  data,
  ...props
}) => {
  const onEdit = () => handleChangeEdit(rowData[dataKey]);
  const onDelete = () => handleChangeDelete(rowData[dataKey]);
  const canDelete = !(
    rowData.purchaseorderitemdetails &&
    rowData.purchaseorderitemdetails.purchaseorder.purchase_order_status ===
      "Send To Client"
  );

  // const isRFI = data.map((item, index) => {
  //   // isRfi(item.rfi);
  //   if (item.rfi === null) {
  //     return false;
  //   }
  //   return item.rfi;
  // });

  const handleFlagData = () => {
    handleFlag(rowData[dataKey]);
    // const isRfi = data.find((item) => item.id === rowData[dataKey]);
  };

  const getStatus = (rowData) => {
    if (rowData.purchaseorderitemdetails != null) {
      if (
        rowData.purchaseorderitemdetails.purchaseorder.purchase_order_status ==
        "Send To Client"
      ) {
        return false;
      }
    }
    return true;
  };

  return (
    <Cell {...props} className="link-group">
      <div style={{ margin: -10, display: "flex", gap: 8 }}>
        {/* <button
          style={{ background: "transparent" }}
          onMouseOver={() => handleFlagData(rowData[dataKey])}
        >
          <Tooltip
            title={leftDays ? `RFI Deadline Ends In ${leftDays} days` : "Flag"}
            placement="bottom-start"
            arrow
          >
            <FlagIcon sx={{ color: colors.success }} />
          </Tooltip>
        </button> */}
        {isUpdate && (
          <IconButton onClick={onEdit}>
            <Tooltip title="Edit">
              <EditIcon />
            </Tooltip>
          </IconButton>
        )}
        {isStatus && canDelete && (
          <IconButton onClick={onDelete}>
            <Tooltip title="Delete">
              <DeleteIcon sx={{ color: colors.danger }} />
            </Tooltip>
          </IconButton>
        )}
      </div>
    </Cell>
  );
};

// Cell for clickable view link
const ActionCells = ({ rowData, dataKey, handleView, ...props }) => (
  <Cell {...props} className="link-group">
    <div style={{ marginLeft: 10 }}>
      <b onClick={() => handleView(rowData)} style={{ cursor: "pointer" }}>
        {rowData[dataKey]}
      </b>
    </div>
  </Cell>
);

// const StatusCell = ({ rowData, dataKey, ...props }) => {
//   return (
//     <Cell {...props} className="link-group">
//       <Chip
//         label={rowData[dataKey] ? "Active" : "Inactive"}
//         type={rowData[dataKey] ? "active" : "inactive"}
//       />
//     </Cell>
//   );
// };

const BudgetItemTable = (props) => {
  const {
    data,
    handleChangeDelete,
    handleChangeEdit,
    handleChangeCheck,
    mapableData,
    searchProp,
    handleView,
    isUpdate,
    isStatus,
    isAddRfi,
    isAddRfq,
    handleFlag,
    leftDays,
    handleSearchSubmit,
    searchValue,
    setSearchValue,
    getAlldata,
    rowsPerPage,
    handleSelectAll,
    vendorDropDown,
  } = props;
  const [allData, setAllData] = React.useState(data);
  const [searchedData, setSearchedData] = React.useState(data);
  const [limit, setLimit] = React.useState(rowsPerPage);
  const [page, setPage] = React.useState(1);
  const [sortColumn, setSortColumn] = React.useState();
  const [sortType, setSortType] = React.useState();
  const [columnFilters, setColumnFilters] = React.useState({});
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [activeColumn, setActiveColumn] = React.useState(null);

  const [isLoader, setisLoader] = React.useState(false);
  const [newdata, setNewdata] = React.useState();
  const [tempData] = React.useState(data);
  const [globalAnchorEl, setGlobalAnchorEl] = React.useState(null);
  const [preview, setPreview] = React.useState(null);
  const [previewPos, setPreviewPos] = React.useState({ x: 0, y: 0 });

  const [visibleColumns, setVisibleColumns] = React.useState(
    mapableData.reduce((acc, col) => {
      acc[col.dataKey] = true;
      return acc;
    }, {})
  );

  const toggleColumn = (key) => {
    setVisibleColumns((prev) => ({ ...prev, [key]: !prev[key] }));
  };

  // const CheckCell = ({
  //   rowData,
  //   handleChangeCheck,
  //   checkedKeys,
  //   dataKey,
  //   isAddRfi,
  //   isAddRfq,
  //   ...props
  // }) => (
  //   <Cell {...props} style={{ padding: 0 }}>
  //     <div style={{ lineHeight: "42px" }}>
  //       {(isAddRfi || isAddRfq) && (
  //         <Checkbox
  //           value={rowData[dataKey]}
  //           inline
  //           onChange={() => handleChangeCheck(rowData[dataKey])}
  //           checked={rowData["checked"]}
  //           style={{ color: colors.primary }}
  //         />
  //       )}
  //     </div>
  //   </Cell>
  // );

  const cellStyle = {
    whiteSpace: "normal",
    wordBreak: "break-word",
  };
  // Update allData when data prop changes
  React.useEffect(() => {
    setAllData(data);
    setSearchedData(data);
  }, [data]);

  const buildFilter = (filter) => {
    let query = {};
    Object.entries(filter).forEach(([key, val]) => {
      if (Array.isArray(val) && val.length > 0) query[key] = val;
    });
    return query;
  };

  const filterBuilderData = (dataset, query) => {
    let result = [];
    dataset.forEach((item) => {
      for (let key in query) {
        if (
          !_.includes(result, item) &&
          String(item[key] ?? "")
            .toLowerCase()
            .includes(query[key][0].toLowerCase())
        ) {
          result.push(item);
        }
      }
    });
    return result;
  };

  const handleSearch = (e) => {
    const val = e.value;
    setSearchValue(e);
    if (val === "") {
      getAlldata();
    }
  };

  // Watch search props to filter data
  React.useEffect(() => {
    let filterObj = {};
    props.searchProp.forEach(
      (key) => (filterObj[key] = [searchValue?.value || ""])
    );
    setSearchedData(filterBuilderData(allData, buildFilter(filterObj)));
  }, [searchValue, allData]);

  // Combined filtering + sorting
  const filteredData = React.useMemo(() => {
    let filtered = searchedData;
    // Column filters
    Object.entries(columnFilters).forEach(([key, val]) => {
      if (val) {
        filtered = filtered.filter((item) =>
          String(_.get(item, key) ?? "")
            ?.toLowerCase()
            .includes(val)
        );
      }
    });
    // Sorting
    if (sortColumn && sortType) {
      filtered = _.orderBy(filtered, [sortColumn], [sortType]);
    }
    return filtered;
  }, [searchedData, columnFilters, sortColumn, sortType]);

  // Pagination slice + formatting
  const filterData = (dataset) => {
    const start = limit * (page - 1);
    return dataset.slice(start, start + limit).map((item) => {
      const details = item?.budgetquantitydetails;

      if (details) {
        const convertedPrice = details.converted_actual_price;
        if (convertedPrice != null) {
          details.converted_actual_price = Number(convertedPrice).toFixed(2);
        }

        const actualPrice = details.actual_price;
        if (actualPrice != null) {
          details.actual_price = Number(actualPrice).toFixed(2);
        }
      }

      return item;
    });
  };

  const handleOpenPopover = (e, key) => {
    setActiveColumn(key);
    setAnchorEl(e.currentTarget);
  };

  const handleClosePopover = () => {
    setActiveColumn(null);
    setAnchorEl(null);
  };

  const debouncedGetAllData = React.useRef(
    debounce((updatedFilters) => {
      const controlNumber = updatedFilters?.control_number || null;
      const vendorName =
        updatedFilters?.["budget_vendordetails.vendordata.name"] || null;
      const otherEntries = Object.entries(updatedFilters).filter(
        ([key]) =>
          key !== "control_number" &&
          key !== "budget_vendordetails.vendordata.name"
      );

      let searchValue = null;
      if (otherEntries.length === 1) {
        searchValue = otherEntries[0][1] || null;
      } else if (otherEntries.length > 1) {
        searchValue = Object.fromEntries(otherEntries);
      }
      getAlldata(null, null, null, searchValue, controlNumber, vendorName);
    }, 1000)
  ).current;

  const handleColumnFilterChange = (key, val) => {
    const updatedFilters = { ...columnFilters, [key]: val };

    setColumnFilters(updatedFilters);

    debouncedGetAllData(updatedFilters);
  };

  const handleSortColumn = (col, type) => {
    setSortColumn(col);
    setSortType(type);
    setSearchedData(_.orderBy(allData, [col], [type]));
  };

  const handleChangeLimit = (newLimit) => {
    setPage(1);
    setLimit(newLimit);
  };

  // Checkbox selection
  const [checkedKeys, setCheckedKeys] = React.useState([]);
  const allChecked = checkedKeys.length === data.length;
  const indeterminate =
    checkedKeys.length > 0 && checkedKeys.length < data.length;
  const handleCheckAll = (_, val) => {
    const keys = val ? data.map((i) => i.id) : [];
    setCheckedKeys(keys);
    handleSelectAll(val);
  };

  const getStatus = (item) => {
    if (item.purchaseorderitemdetails != null) {
      if (
        item.purchaseorderitemdetails.purchaseorder.purchase_order_status ==
        "Send To Client"
      ) {
        return false;
      }
    }
    return isStatus;
  };

  return (
    <>
      {isLoader && <LoaderComponent />}
      <div
        style={{
          display: "flex",
          alignItems: "center",
          gap: 10,
        }}
      >
        {/* Column Chooser */}
        <div className="chooseColumn">
          <Popover
            open={Boolean(globalAnchorEl)}
            anchorEl={globalAnchorEl}
            onClose={() => setGlobalAnchorEl(null)}
            anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          >
            <div style={{ padding: 12 }}>
              {mapableData.map((col) => (
                <div key={col.dataKey} style={{ marginBottom: 8 }}>
                  <Checkbox
                    checked={visibleColumns[col.dataKey]}
                    onChange={() => toggleColumn(col.dataKey)}
                  >
                    {col.title}
                  </Checkbox>
                </div>
              ))}
            </div>
          </Popover>

          <div className="tablebudget">
            <IconButton
              size="small"
              onClick={(e) => setGlobalAnchorEl(e.currentTarget)}
            >
              <TuneIcon fontSize="small" />
            </IconButton>
          </div>
        </div>
        {/* Search */}
        <form onSubmit={handleSearchSubmit}>
          <FormTextInput
            type="text"
            className="searchBarBudget mb-3"
            placeholder="Search..."
            Value={searchValue?.value}
            onChangeText={handleSearch}
            inputStyle={{ border: "1px solid #ccc" }}
            editable
          />
        </form>
      </div>

      <div style={{ overflowY: "auto" }}>
        <Table
          virtualized={filterData(filteredData).length < 0}
          height={600}
          data={filterData(filteredData)}
          sortColumn={sortColumn}
          sortType={sortType}
          onSortColumn={handleSortColumn}
          rowHeight={70}
          headerHeight={50}
          style={{ borderRadius: 8 }}
        >
          {/* Select all checkbox */}
          <Column width={50} align="center">
            <HeaderCell>
              <Checkbox
                checked={allChecked}
                indeterminate={indeterminate}
                onChange={handleCheckAll}
              />
            </HeaderCell>
            <Cell style={cellStyle}>
              {(rowData) =>
                (isAddRfi || isAddRfq) && (
                  <Checkbox
                    inline
                    value={rowData.id}
                    checked={rowData.checked}
                    onChange={() => handleChangeCheck(rowData.id)}
                  />
                )
              }
            </Cell>
          </Column>

          {/* Data columns */}
          {mapableData.map((col, i) =>
            visibleColumns[col.dataKey] ? (
              <Column key={i} minWidth={100} resizable>
                <HeaderCell
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    whiteSpace: "normal",
                  }}
                >
                  <span style={{ fontWeight: 600, color: colors.primary }}>
                    {col.title}
                  </span>
                  <IconButton
                    size="small"
                    onClick={(e) => handleOpenPopover(e, col.dataKey)}
                  >
                    <MoreVertIcon fontSize="small" />
                  </IconButton>

                  <Popover
                    open={activeColumn === col.dataKey}
                    anchorEl={anchorEl}
                    onClose={handleClosePopover}
                    anchorOrigin={{ vertical: "bottom", horizontal: "center" }}
                    transformOrigin={{ vertical: "top", horizontal: "center" }}
                  >
                    <div
                      style={{
                        padding: 12,
                        maxWidth: 240,
                        width: "10rem",
                        display: "flex",
                        flexDirection: "column",
                        gap: 12,
                      }}
                    >
                      {col.title?.toLowerCase() === "vendor" ? (
                        <Autocomplete
                          style={{ width: "9rem" }}
                          id="combo-box-demo"
                          options={vendorDropDown || []}
                          sx={{ width: "100%" }}
                          onChange={(event, newValue) => {
                            handleColumnFilterChange(
                              col.dataKey,
                              newValue?.key
                            );
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Select vendor"
                              size="small"
                            />
                          )}
                        />
                      ) : (
                        <TextField
                          label={`Search ${col.title}`}
                          variant="outlined"
                          size="small"
                          fullWidth
                          value={columnFilters[col.dataKey] ?? ""}
                          onChange={(e) =>
                            handleColumnFilterChange(
                              col.dataKey,
                              e.target.value
                            )
                          }
                          autoFocus
                        />
                      )}

                      <div style={{ fontWeight: "bold", marginBottom: 8 }}>
                        Sort Order
                      </div>

                      {["None", "asc", "desc"].map((order) => (
                        <label
                          key={order}
                          style={{ display: "block", marginBottom: 4 }}
                        >
                          <input
                            type="radio"
                            name={`sort-${col.dataKey}`}
                            value={order === "None" ? "" : order}
                            checked={
                              order === "None"
                                ? sortColumn !== col.dataKey
                                : sortColumn === col.dataKey &&
                                  sortType === order
                            }
                            onChange={() => {
                              if (order === "None") {
                                setSortColumn(null);
                                setSortType(null);
                              } else {
                                setSortColumn(col.dataKey);
                                setSortType(order);
                              }
                              handleClosePopover();
                            }}
                          />{" "}
                          {order.charAt(0).toUpperCase() + order.slice(1)}
                        </label>
                      ))}
                    </div>
                  </Popover>
                </HeaderCell>

                {col.dataKey === "file_path" ? (
                  <Cell>
                    {(rowData) =>
                      rowData.file_path ? (
                        <img
                          src={rowData.file_path}
                          alt="Item"
                          style={{
                            width: "50px",
                            height: "50px",
                            objectFit: "contain",
                            padding: "2px",
                            borderRadius: "8px",
                            cursor: "zoom-in",
                          }}
                          onMouseEnter={() => setPreview(rowData.file_path)}
                          onMouseLeave={() => setPreview(null)}
                          onMouseMove={(e) => {
                            const previewWidth = 300;
                            const previewHeight = 260;
                            const margin = 20;

                            const posX =
                              e.clientX - previewWidth - margin < 0
                                ? e.clientX + margin
                                : e.clientX - previewWidth - margin;

                            let posY = e.clientY;

                            const bottomSpace = window.innerHeight - e.clientY;

                            if (bottomSpace < previewHeight + margin) {
                              posY =
                                window.innerHeight - previewHeight - margin;
                            }

                            setPreviewPos({
                              x: posX,
                              y: posY,
                            });
                          }}
                        />
                      ) : (
                        "-"
                      )
                    }
                  </Cell>
                ) : col.isviewlink ? (
                  <ActionCells
                    dataKey={col.dataKey || "control_number"}
                    handleView={handleView}
                  />
                ) : col.isAction ? (
                  <ActionCell
                    dataKey={col.dataKey || "id"}
                    handleChangeDelete={handleChangeDelete}
                    handleChangeEdit={handleChangeEdit}
                    isUpdate={isUpdate}
                    isStatus={isStatus}
                  />
                ) : col.render ? (
                  <Cell>{(rowData) => col.render(rowData)}</Cell>
                ) : (
                  <Cell dataKey={col.dataKey} style={cellStyle} />
                )}
              </Column>
            ) : null
          )}
        </Table>

        {preview && (
          <div
            style={{
              position: "fixed",
              top: previewPos.y,
              left: previewPos.x,
              zIndex: 5000,
              background: "#fff",
              border: "1px solid #ccc",
              padding: 6,
              borderRadius: 8,
              boxShadow: "0 4px 12px rgba(0,0,0,0.15)",
            }}
          >
            <img
              src={preview}
              style={{ width: 260, height: "auto", borderRadius: 6 }}
            />
          </div>
        )}
      </div>
    </>
  );
};

export default BudgetItemTable;
